var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"relative"},[(_vm.content)?_c('block-list',{attrs:{"blocks":_vm.content.blocks,"enable-container":false}}):_vm._e(),(_vm.loading)?_c('spinner-overlay',{staticClass:"top-30",attrs:{"show":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }